module.exports = __webpack_public_path__ + "img/stop_btn.a74926d4.png";